<!--
 * @Author: yyl
 * @Date: 2025-06-25 10:39:40
 * @LastEditTime: 2025-07-03 11:30:53
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/views/TeachersView.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div>
    <div class="container">
      <div class="flex">
        <div style="width: 17%" v-if="!isMobile">
          <div class="card-right--title">相关栏目</div>

          <div
            class="card-right--item"
            v-for="item in sectionData.leftMenu"
            :key="item.id"
            :style="{ background: nowLocation.id === item.id ? '#D6D6D6' : '' }"
            @click="handleMenuItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>

        <div
          :span="20"
          style="
            flex: 1;
            background-color: #f2f2f2;
            padding-left: 10px;
            padding-right: 4px;
          "
        >
          <div class="">
            <div style="padding: 10px" class="flex items-center">
              <i
                class="el-icon-s-home"
                style="color: #606266; font-size: 16px"
              />

              <div style="color: #606266; font-size: 14px; padding: 0 5px">
                当前位置:
              </div>

              <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in location" :key="item.id">{{
                  item.title
                }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>

          <div style="border: 1px solid #e0dcdc; border-radius: 4px">
            <div class="main-tag" style="">
              {{ nowLocation.title }}
            </div>
          </div>

          <div
            class="item"
            v-for="(item, index) in listData.data"
            :key="item.id || index"
          >
            <div class="box-card">
              <div>
                <div style="">
                  <div style="width: 19%; display: inline-block">
                    <el-image
                      :src="item.thumb_pic"
                      fit="cover"
                      style="width: 80%; height: auto"
                    />
                  </div>
                  <div
                    style="
                      width: 81%;
                      display: inline-block;
                      vertical-align: top;
                    "
                  >
                    <div>
                      <div
                        class="list-item__title"
                        style="font-weight: bold; cursor: pointer"
                        @click="handleGoDetailClick(item)"
                      >
                        {{ item.title }}
                      </div>
                      <div style="font-size: 13px; padding: 10px 0">
                        {{ item.content }}
                      </div>
                      <div
                        style="
                          font-size: 13px;
                          text-align: right;
                          color: #aaa;
                          margin-top: 20px;
                        "
                      >
                        [日期]：
                        {{ item.created_at }}
                        [访问]：
                        {{ item.page_views }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="text-align: center; padding: 10px">
            <el-pagination
              background
              hide-on-single-page
              layout="total, prev, pager, next, jumper"
              :total="listData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchListData } from "@/api/home"
import resizeMixin from "@/mixins/resize"

export default {
  name: "ListView",

  mixins: [resizeMixin],

  data() {
    return {
      title: "",
      section_id: "",
      sectionData: {
        location: [],
      },
      location: [],
      nowLocation: {},
      page: 1,
      page_size: 10,
      listData: {},
    }
  },

  created() {
    this.title = this.$route.query.title

    this.section_id = this.$route.query.section_id
    this.getListData()
  },

  methods: {
    async getListData() {
      try {
        const res = await fetchListData({
          section_id: this.section_id,
          page: this.page,
          page_size: this.page_size,
        })
        this.sectionData = res
        this.location = res.location || []
        this.nowLocation = this.location[this.location.length - 1] || {}
        this.listData = res.list || {}
      } catch (err) {
        console.error("加载失败", err)
      }
    },

    handleGoDetailClick(item) {
      console.log(item)
      this.$router.push(`/article?id=${item.id}`)
    },

    safePush(path, query) {
      if (
        this.$route.path != path ||
        JSON.stringify(this.$route.query) != JSON.stringify(query)
      ) {
        this.$router.push({ path, query })
      }
    },

    handleMenuItemClick(item) {
      console.log(`handleMenuItemClick`, item)

      // Article = 1,
      // List = 2,
      // Image_Text = 3,
      // Image = 4,
      // Link = 5,

      if (item === 0) {
        this.$router.push("/")
      }

      if ([5].includes(item.content_model_id)) {
        window.open(item.url, "_blank")
      } else if ([4].includes(item.content_model_id)) {
        this.safePush(`/teachers`, {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([2].includes(item.content_model_id)) {
        this.safePush("/list", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([3].includes(item.content_model_id)) {
        this.safePush("/list-image", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([1].includes(item.content_model_id)) {
        this.safePush(`/article`, {
          content_model_id: item.content_model_id,
          id: String(item.id),
        })
      }

      this.drawerVisible = false
    },

    // handleMenuItemClick(item) {
    //   console.log(`handleMenuItemClick`, item)

    //   //     Article = 1,
    //   // List = 2,
    //   // Image_Text = 3,
    //   // Image = 4,
    //   // Link = 5,

    //   // const maps = {
    //   //   1: "Article",
    //   //   2: "List",
    //   // }

    //   const listType = [2, 3]

    //   if ([5].includes(item.content_model_id)) {
    //     window.open(item.url, "_blank")
    //   } else if (listType.includes(item.content_model_id)) {
    //     // this.safePush(
    //     //   this.$router,
    //     //   `/list?section_id=${item.id}&title=${item.title}`
    //     // )

    //     this.section_id = item.section_id
    //     this.getListData()
    //   } else if ([1].includes(item.content_model_id)) {
    //     this.safePush(
    //       this.$router,
    //       `/article?content_model_id=${item.content_model_id}&id=${item.id}`
    //     )
    //   } else if (item.pid === 0) {
    //     this.safePush(this.$router, "/")
    //   }

    //   this.drawerVisible = false
    // },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.getListData()
    },

    onResize() {
      this.isMobile = window.innerWidth < 768 // 当窗口宽度小于 768px 时，认为是移动端
    },
  },
}
</script>

<style scoped lang="scss">
.card-right--title {
  height: 74px;
  line-height: 74px;
  color: #fff;
  text-align: center;
  // background-color: #005db3;
  background-color: #1c3a97;
}
.box-card {
  padding: 10px;
  padding-right: 20px;
  background-color: #fff;
  margin: 12px 0;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(235, 238, 245);
}

.card-right--item {
  text-align: center;
  line-height: 32px;
  padding: 6px 10px;

  border: 1px solid #e0dcdc;
  border-top: none;
  cursor: pointer;

  &:hover {
    background-color: #d6d6d6;
  }
}

.main-tag {
  display: inline-block;
  padding: 5px 24px;
  background-color: #1c3a97;
  color: #fff;
  position: relative;
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #003665;
    position: absolute;
    bottom: -8px;
    right: 50%;
    margin-right: -8px;
  }
}

.list-item {
  font-size: 14px;
  padding: 5px 10px;

  cursor: pointer;

  &__title {
    &:hover {
      color: #15458b;
      text-decoration: underline;
    }
  }
}

.item {
  &:nth-child(2n) {
    .list-item {
      background-color: #f8f9fb;
    }
  }
}

.title-link {
  &:hover {
    color: #15458b;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
